import React, { useState, useEffect } from 'react';
import {
	Box,
	HStack,
	Table,
	Thead,
	Tbody,
	Tr,
	Th,
	Td,
	TableContainer,
	useDisclosure,
	Menu,
	MenuButton,
	MenuList,
	MenuItem,
	Icon,
} from '@chakra-ui/react'
import { LuChevronDown } from 'react-icons/lu'
import CustomModal from '../../../components/CustomModal'
import Create from './Create';
import { fetchWrapper } from '../../../helpers';
import PageLoader from '../../../components/Loader/PageLoader';

function List() {

	const { isOpen, onOpen, onClose } = useDisclosure();
	const [isOpenEdit, setIsOpenEdit] = useState(false)
	const [list, setList] = useState([])
	const [rs, setrs] = useState({})
	const [loading, setLoading] = useState(false);

	const meClose = () => {
		setIsOpenEdit(false);
		onClose();
	}

	useEffect(() => {
		loadList();
	}, [])

	const loadList = async () => {
		setLoading(true)
		const url = `${process.env.REACT_APP_API_URL}/template-message/list`;
		const data = await fetchWrapper.get(url)
		setList(data.data);
		setLoading(false)
	}

	const meEdit = (rs) => {
		setIsOpenEdit(true);
		onOpen()
		setrs(rs)
	}


	const styleTextWithVariables = (text) => {
		// Regex to match variables starting with $
		const regex = /\$[a-zA-Z_][a-zA-Z0-9_]*/g;
		return text.split(regex).reduce((acc, part, i, arr) => {
			// Find all matches
			const matches = text.match(regex) || [];
			acc.push(
				<span key={`text-${i}`}>
					{part}
				</span>
			);
			if (matches[i]) {
				acc.push(
					<span key={`var-${i}`} style={{ color: 'blue' }}>
						{matches[i]}
					</span>
				);
			}
			return acc;
		}, []);
	};
	return (
		<>

			<PageLoader isLoading={loading} />
			
			<div className="setting_detail_section">
				<HStack justifyContent="space-between">
					<Box>
						<h2 className="main_heading">Template Messages</h2>
					</Box>
					<Box>
						<CustomModal
							showModalButtonText="Add New Message Template"
							modalHeader="Add New Message Template"
							isOpen={isOpen}
							onClose={meClose}
							onOpen={onOpen}
							size='xl'
							modalBody={<Create meClose={meClose} loadList={loadList} isOpenEdit={isOpenEdit} rs={rs} />}
						/>
					</Box>
				</HStack>

				<div className="table_section">
					<TableContainer width="100%">
						<Table variant='simple' width="100%" borderWidth="1px" borderColor="#CCCCCC" borderStyle="solid">
							<Thead>
								<Tr>
									<Th width="15%">Template Name</Th>
									<Th width="40%">Message</Th> {/* Increased width for message column */}
									<Th width="15%">Template Type</Th>
									{/* <Th width="15%">Channel</Th> */}
									<Th width="10%">WhatsApp Template</Th>
									<Th width="5%"></Th>
								</Tr>
							</Thead>

							<Tbody fontSize="14px">
								{list.map((rs, index) => {
									return (
											<Tr>
												<Td>{rs.name}</Td>
												<Td sx={{
													whiteSpace: 'normal',
													wordBreak: 'break-word',
													minWidth: '400px',
													maxWidth: '40%',
													p: 4,
													verticalAlign: 'top'
												}}>{styleTextWithVariables(rs.message)}</Td>
												<Td>{rs.MessageTemplateType?.name}</Td>
												{/* <Td>{rs.channel_id}</Td> */}
												<Td>{rs.whatsapp_template_name}</Td>
												<Td style={{ color: "#0000EE" }}>
													<Menu>
														<MenuButton fontSize="14px" >
															Action

															<Icon as={LuChevronDown} />
														</MenuButton>
														<MenuList style={{ minWidth: "20px", border: "1px solid #CCCCCC" }}>
															<MenuItem h="16px" fontSize="12px" onClick={() => meEdit(rs)}>Edit</MenuItem>
														</MenuList>
													</Menu>
												</Td>
											</Tr>
									)
								})}
							</Tbody>
						</Table>
					</TableContainer>
				</div>
			</div>
		</>
	)
}


export default List
